import * as tslib_1 from "tslib";
import { OnInit, OnDestroy, EventEmitter } from '@angular/core';
import { AuthService } from '../../../../core/services/auth.service';
import { DataVehiculosService } from '../../../modulos/general/componentes/gestion-vehiculos/services/data-vehiculos.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { environment } from '../../../../../environments/environment';
import { ToastrService } from 'ngx-toastr';
export class VehicleSelectComponent {
    constructor(toastr, _authService, _dataVehiculosService, modalService) {
        this.toastr = toastr;
        this._authService = _authService;
        this._dataVehiculosService = _dataVehiculosService;
        this.modalService = modalService;
        this.modalCloseVehicle = new EventEmitter();
        this.modalOption = {};
        this.familyAuto = [
            {
                title: '',
                th: ['Modelo', 'LCDV', 'Año', 'Modificación'],
                fields: ['VersionText', 'Version16', 'VersionYear', 'ModYearText'],
                gridView: {}
            }
        ];
        this.siluetaOption = true;
        this.motorOption = true;
        this.transmissionOption = true;
        this.loading = false;
    }
    ngOnInit() {
        this.getFamilies();
    }
    getFamilies() {
        const params = { 'searchValue': '' };
        const _URL_ = `${environment.ENTORNO}Services/Workshop/VehicleService.svc/GetFamilies`;
        this._dataVehiculosService.getFamilies(_URL_, params).subscribe(data => {
            const auxData = data.Response;
            if (auxData) {
                this.dataFamilyAuto = auxData;
            }
        });
    }
    silueta() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const _URL_ = `${environment.ENTORNO}Services/Workshop/VehicleService.svc/GetContoursByFamilyCode`;
            const params = {
                'searchValue': this.familyCode,
                'orderBy': null
            };
            const combo1Fetch = this._dataVehiculosService.getContours(_URL_, params).subscribe(data => {
                const auxdata = data.Response;
                if (auxdata) {
                    this.dataSiluetaAuto = auxdata;
                }
            });
            return combo1Fetch;
        });
    }
    motor() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const _URL_ = `${environment.ENTORNO}Services/Workshop/VehicleService.svc/GetEngineByFamilyCode`;
            const params = {
                'searchValue': this.familyCode,
                'orderBy': null
            };
            const combo2Fetch = this._dataVehiculosService.getEngineMotor(_URL_, params).subscribe(data => {
                const auxdata = data.Response;
                if (auxdata) {
                    this.dataMotorAuto = auxdata;
                }
            });
            return combo2Fetch;
        });
    }
    transmision() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const _URL_ = `${environment.ENTORNO}Services/Workshop/VehicleService.svc/GetTransmissionsByFamilyCode`;
            const params = {
                'searchValue': this.familyCode,
                'orderBy': null
            };
            const combo3Fetch = this._dataVehiculosService.getTransmissionsByFamily(_URL_, params).subscribe(data => {
                const auxdata = data.Response;
                if (auxdata) {
                    this.dataTransmission = auxdata;
                }
            });
            return combo3Fetch;
        });
    }
    onChangeSilueta(event) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.familyCode = event;
            this.contourCode = ''; // dejo vacio el combo2
            this.engineCode = ''; // dejo vacio el combo3
            this.transmissionCode = ''; // dejo vacio el combo4
            try {
                const combo1 = yield this.silueta();
                const combo2 = yield this.motor();
                const combo3 = yield this.transmision();
                this.getDataTable();
            }
            catch (error) {
            }
        });
    }
    onChangeMotor(event) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.contourCode = event;
            this.engineCode = ''; // dejo vacio el combo3
            this.transmissionCode = ''; // dejo vacio el combo4
            try {
                const combo2 = yield this.motor();
                const combo3 = yield this.transmision();
                this.getDataTable();
            }
            catch (error) {
            }
        });
    }
    onChangeTransmission(event) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.engineCode = event;
            this.transmissionCode = ''; // dejo vacio el combo4
            try {
                const combo3 = yield this.transmision();
                this.getDataTable();
            }
            catch (error) {
            }
        });
    }
    onChangeLast(event) {
        this.transmissionCode = event;
        this.getDataTable();
    }
    ngOnDestroy() { }
    onTabSelect(event) { }
    //result es la pantalla
    closeModal(result, datos) {
        if (result && datos) {
            const params = {
                'pantalla': 'vehicleSelectorForm',
                'datosForm': datos
            };
            this.modalCloseVehicle.emit(params);
        }
        else {
            const params = {
                'pantalla': 'vehicleSelectorForm',
                'datosForm': null
            };
            this.modalCloseVehicle.emit(params);
        }
    }
    getDataTable() {
        this.loading = true;
        const _URL_ = `${environment.ENTORNO}Services/Workshop/VehicleService.svc/GetCarModelsPaged`;
        const params = {
            'description': '',
            'familyCode': this.familyCode,
            'contourCode': this.contourCode,
            'engineCode': this.engineCode,
            'transmissionCode': this.transmissionCode,
            pageInfo: { Number: 1, Size: 20 }
        };
        this._dataVehiculosService.getCarModel(_URL_, params).subscribe(data => {
            const auxData = data.Response.Content;
            if (data.Response) {
                this.dataResolve = auxData;
                this.familyAuto[0]['gridView'] = {
                    data: this.dataResolve,
                    total: this.dataResolve.length
                };
            }
        });
        this.loading = false;
    }
    selectRow(event) {
        const datosForm = event.dataItem;
        this.closeModal('vehicleSelectorForm', datosForm);
        // this.modeloCarSearch.emit(event.dataItem);
    }
}
